import Navbar from "./Navbar";
import CollegeActivities from "./College_Activities/College_Activities";
import Titles from "./College_Activities/Titles";
import HexagonGrids from "./College_Activities/Hexagon_Grid";
import YogaSection from "./College_Activities/Yoga_Section";
import Blog from "./College_Activities/Blog_Card";
import Footer from "./Footer";
import './Css/College_Activities.css';

function CollegeActivitiesMain() {
  return (
    <div>
      <Navbar />
      <CollegeActivities  />
      <Titles />
      <YogaSection />
      {/* <HexagonGrids /> */}
      <Blog />
      <Footer />
    </div>
  );
}

export default CollegeActivitiesMain;